import request from "@/utils/request"

export default function agentRefundOrder(id) {
    return request.post(
        `/fund/order/agentRefundOrder/${id}`, {}, {
            params: {
                orderId: id
            }
        }
    )
}

